<template>
  <div>
    <div v-if="itemtype === 'accomodation'">
      <div v-if="isCvVilla(item.supplier) && this.villaData">
        <CvVillasModal ref="cvVillasModal" :villaData="villaData" />
        <button @click="openCvVillasModal">
          <i class="material-icons vtd-icon-2 vtd-mr-3">info</i>
          <span>Villa Information</span>
        </button>
      </div>

      <div v-else-if="isSolmarVilla(item.supplier) && this.villaData">
        <SolmarVillasModal ref="solmarVillasModal" :villaData="villaData" />
        <button @click="openSolmarVillasModal">
          <i class="material-icons vtd-icon-2 vtd-mr-3">info</i>
          <span>Villa Information</span>
        </button>
      </div>

      <button
        class="hotel-modal"
        v-if="item.htlpagelink && json.length"
        @click="
          () => {
            $refs.HotelInfoRef.show(item.htlpagelink);
          }
        "
      >
        <i class="material-icons vtd-icon-2 vtd-mr-3"></i
        ><span>{{ capitalise(item.suppliername) }}</span>
      </button>

      <a
        v-if="item.holesswithdir"
        target="blank"
        :href="`https://www.trailfinders.com/${item.holesswithdir}`"
      >
        <button>
          <i class="material-icons vtd-icon-2 vtd-mr-3"></i>
          Click here for essential information on<br />{{
            capitalise(item.suppliername)
          }}
        </button>
      </a>
      <HotelInfo ref="HotelInfoRef" />
    </div>

    <div v-if="itemtype === 'transfer'">
      <a
        v-if="item.holesswithdir"
        target="blank"
        :href="`https://www.trailfinders.com/${item.holesswithdir}`"
      >
        <button>
          <i class="material-icons vtd-icon-2 vtd-mr-3"></i>
          Click here for essential information on<br />{{
            capitalise(item.operator)
          }}
        </button>
      </a>
    </div>

    <div v-if="itemtype === 'carhire'">
      <button
        v-if="item.holesswithdir"
        class="extra-info-btn"
        @click="openLink(item.holesswithdir)"
      >
        <i class="material-icons vtd-icon-2 vtd-mr-3"></i
        ><span>Car Hire Holiday Essentials</span>
      </button>
    </div>

    <div v-if="itemtype === 'motorhome'">
      <button v-if="depotfile" class="btn-info" @click="openLink(depotfile)">
        <i class="material-icons vtd-icon-2 vtd-mr-3"></i
        ><span>{{ capitalise(depotfiletitle) }}</span>
      </button>
      <button
        v-if="vehiclefile"
        class="btn-info"
        @click="openLink(vehiclefile)"
      >
        <i class="material-icons vtd-icon-2 vtd-mr-3"></i
        ><span>{{ capitalise(vehiclefiletitle) }}</span>
      </button>
    </div>

    <button
      v-if="productSupplier && item.tourtype === 'CRUISE'"
      class="btn-info"
      @click="openProductSupModal"
    >
      <i class="material-icons vtd-icon-2 vtd-mr-3">info</i>
      <span>Essential Cruise Information</span>
    </button>
    <button
      v-else-if="productSupplier"
      class="btn-info"
      @click="openProductSupModal"
    >
      <i class="material-icons vtd-icon-2 mr-3">info</i>
      <span>Essential
        {{ item.jsontype.charAt(0).toUpperCase() + item.jsontype.slice(1) }}
        Information</span>
    </button>
    <button
      v-if="checkInSupplier && fil === 'M' && isValidProduct"
      class="btn-info"
      @click="openCheckInModal"
    >
      <i class="material-icons vtd-icon-2 vtd-mr-3">info</i>
      <span>Action Required</span>
    </button>

    <div v-if="item.suppliername == 'JET2HOLIDAYS'">
      <Jet2Info ref="Jet2InfoRef" :item="item" />
    </div>

    <EssentialInfo ref="EssentialInfoRef" :item="item" />

    <button
      v-if="item.meetmsg[0].msgcode"
      class="btn-info"
      @click="openGeneralModal()"
    >
      <i class="material-icons vtd-icon-2 vtd-mr-3">info</i>
      <span>{{ item.meetmsg[0].title }}</span>
    </button>

    <ViewVoucherButton
      v-if="showViewVoucher === 'viewTFVoucher'"
      :type="'tf'"
      :vouchno="item.vouchno"
      @open-voucher="openVoucher('tf', item.vouchno, null)"
    />
    <ViewVoucherButton
      v-if="showViewVoucher === 'viewBedsOnlineVoucher'"
      :type="'bedsonline'"
      :vouchno="item.vouchno"
      @open-voucher="openVoucher('bedsonline', item.vouchno, null)"
    />

    <ViewVoucherButton
      v-if="showViewVoucher === 'viewViatorVoucher'"
      :type="'viator'"
      :vouchno="item.vouchno"
      @open-voucher="openVoucher('viator', item.vouchno, null)"
    />

    <ViewVoucherButton
      v-if="showViewVoucher === 'viewVoucher'"
      :type="'supplier'"
      :vouchno="item.vouchno"
      @open-voucher="openVoucher('supplier', item.vouchno, item.supdocslist[0])"
    />

    <button
      v-if="showViewVoucher === 'viewMultipleVouchers'"
      class="voucher-btn"
      @click="openSupplierMultipleVouchersRef()"
    >
      <i class="material-icons vtd-icon-2 vtd-mr-3">attach_file</i
      ><span>View Voucher</span>
    </button>

    <button
      v-if="showViewVoucher === 'viewAdditionalDocs'"
      class="voucher-btn"
      @click="openAdditionalDocumentsModal()"
    >
      <i class="material-icons vtd-icon-2 vtd-mr-3">attach_file</i
      ><span>View Voucher</span>
    </button>

    <button
      v-if="showViewVoucher === 'essentialInfo'"
      class="voucher-btn"
      @click="openEssentialInfoModal()"
    >
      <i class="material-icons vtd-icon-2 vtd-mr-3">info</i
      ><span>Voucher Information</span>
    </button>

    <button
      v-if="showViewVoucher === 'voucherInfo'"
      class="voucher-btn"
      @click="openNewVoucherModal(item.tfvouch_status)"
    >
      <i class="material-icons vtd-icon-2 vtd-mr-3">info</i
      ><span>Voucher Information</span>
    </button>

    <GroundGeneralModal ref="GroundGeneralModalRef" />

    <SQLMessage ref="SQLMessageRef" />

    <AdditionalDocuments ref="AdditionalDocumentsModalRef" :item="item" />

    <AdditionalDocuments ref="MultipleSupplierVouchersRef" :item="item" />

    <VouchersModal
      ref="VouchersModalRef"
      :item="item"
      :voucherInformation="voucherInformation"
    />
  </div>
</template>

<script>
import HotelInfo from "./info";
import {
  fetchVilla,
  reportVoucherError,
  fetchVoucherInformation,
} from "./services";
import { getSite } from "@/lib/utilities";
import Jet2Info from "@/partials/extra-info-buttons/jet-info";
import VouchersModal from "@/partials/extra-info-buttons/vouchers";
import CvVillasModal from "@/partials/extra-info-buttons/cv-villas";
import EssentialInfo from "@/partials/extra-info-buttons/essential-info";
import SQLMessage from "@/modules/menu-bar/essential-info/sql-message";
import GroundGeneralModal from "@/modules/navigation/modals/ground-general-modal";
import AdditionalDocuments from "@/modules/menu-bar/essential-info/additional-document";
import { mapGetters } from "vuex";
import SolmarVillasModal from "@/partials/extra-info-buttons/solmar-villas";
import ViewVoucherButton from "./view-voucher-button.vue";

export default {
  components: {
    SQLMessage,
    HotelInfo,
    EssentialInfo,
    AdditionalDocuments,
    Jet2Info,
    GroundGeneralModal,
    CvVillasModal,
    VouchersModal,
    SolmarVillasModal,
    ViewVoucherButton,
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
    itemtype: {
      type: String,
      default: null,
    },
    depotfile: {
      type: String,
    },
    depotfiletitle: {
      type: String,
    },
    vehiclefiletitle: {
      type: String,
    },
    vehiclefile: {
      type: String,
    },
  },
  data() {
    return {
      site: getSite(),
      productSupplier: false,
      productDestination: false,
      checkInSupplier: false,
      voucherSupplier: false,
      json: [],
      villaData: null,
      voucherInformation: "",
      isValidProduct: false,
      productTypeOptions: [
        'Hotel (HTL)',
        'Transfer (TRF)',
        'Local Tour (ITX)',
        'Multi Day Tour (ITX)',
        'Adventure Tour (ADV)',
        'Escorted Tour (ESC)',
        'Cruise (CRS)',
        'Car Hire (CAR)',
        'Motorhome Rental (VAN)',
        'Private Tour (TPT)',
        'Rail (RAI)',
        'Wedding (ITP)',
      ],
    };
  },
  async mounted() {
    if (this.item.essentialInformation) {
      if (this.item.essentialInformation.checkInEssential.length > 0) {
        this.checkInSupplier = true;
      }
      if (this.item.essentialInformation.voucherEssential.length > 0) {
        this.voucherSupplier = true;
      }
      this.isValidProduct = this.isValidProductType()
      if (this.item.essentialInformation.productEssential.length > 0) {
        for (const element of this.item.essentialInformation.productEssential) {
          if (element.suppliers) {
            this.productSupplier = true;
          }
          if (element.destinations) {
            this.productDestination = true;
          }
        }
      }
      if (this.item.htlpagelink) {
        this.checkJsonData(this.item.htlpagelink);
      }
    }
    if (this.isCvVilla(this.item.supplier)) {
      this.getVillaData("cv");
    } else if (this.isSolmarVilla(this.item.supplier)) {
      this.getVillaData("solmar");
    }
  },
  computed: {
    showViewVoucher() {
      if (this.item.vouchno && this.item.tourtype !== "CRUISE") {
        if (this.item.tfvouch_status && this.item.tfvouch_status === "ISSUED") {
          return "viewTFVoucher";
        }
        if (this.item.vouchno.startsWith("BEDSONLINE")) {
          return "viewBedsOnlineVoucher";
        }
        if (this.item.vouchno.startsWith("VIATOR")) {
          return "viewViatorVoucher";
        }
      } else if (this.item.suppdoclink === "true") {
        if (this.item.supdocslist.length) {
          if (this.item.supdocslist.length > 1) {
            return "viewMultipleVouchers";
          } else if (this.item.supdocslist.length === 1) {
            if (this.item.supdocslist[0] !== "") {
              return "viewVoucher";
            }
          }
        }
        if (this.additionalSupDocExist) {
          return "viewAdditionalDocs";
        }
      } else if (this.item.essentialInformation.voucherEssential.length > 0) {
        return "essentialInfo";
      } else if (
        this.item.tfvouch_status === "NOT YET READY" ||
        this.item.tfvouch_status === "NOT REQUIRED"
      ) {
        return "voucherInfo";
      } else {
        if (this.accountInfo.fil === "M") {
          this.voucherError();
          return null;
        }
      }
      return null;
    },
    ...mapGetters({
      booking: "booking/getBooking",
      bookingNumber: "booking/getBookingNumber",
      essInfo: "booking/getEssentialInfo",
      essentialInfoMenu: "essentialInfoMenu/getMenu",
      fil: "booking/getFil",
      additionalSupDocExist: "booking/checkForAdditionalSupDocs",
      additionalSupDocIndexes: "booking/getAdditionalSupDocs",
      accountInfo: "booking/getAccount",
    }),
  },
  methods: {
    openLink(_link) {
      window.open(`https://www.trailfinders.${this.site}${_link}`, "_blank");
    },
    openVoucher(flag, vouchno, index) {
      let extension = "";
      if (flag === "supplier") {
        extension = this.essInfo.supplier_documents.filenames[index].replace(
          " ",
          "%20"
        );
      }
      setTimeout(() => {
        if (flag === "tf") {
          window.open(
            `https://www.trailfinders.${this.booking.booking_information.booking_site}/travel-vouchers/${this.booking.user_information.bookingNumber}_${vouchno}.pdf`,
            "_blank"
          );
        } else if (flag === "bedsonline") {
          const param = vouchno.replace(/^BEDSONLINE-/, "");
          window.open(
            `https://www.trailfinders.${this.booking.booking_information.booking_site}/tourdoc/bedsonline/${param}.pdf`,
            "_blank"
          );
        } else if (flag === "viator") {
          const param = vouchno.replace(/^VIATOR-/, "");
          window.open(
            `https://www.trailfinders.${this.booking.booking_information.booking_site}/tourdoc/viator/${param}.pdf`,
            "_blank"
          );
        } else {
          window.open(
            `https://www.trailfinders.${this.booking.booking_information.booking_site}/tourdoc/bybookno/${this.booking.user_information.bookingNumber}/${extension}`,
            "_blank"
          );
        }
      }, 500);
    },
    openAdditionalDocumentsModal() {
      let _tmp = {
        partial: "AdditionalDocumentsModalRef",
        title: "Additional Documents",
        supplier: this.item.operator,
        docIndexes: this.additionalSupDocIndexes,
        message: [this.essInfo.supplier_documents],
        flag: "additional",
      };
      this.$refs.AdditionalDocumentsModalRef.showModal(_tmp);
    },
    openSupplierMultipleVouchersRef() {
      let _tmp = {
        partial: "AdditionalDocumentsModalRef",
        title: "Additional Documents",
        supplier: this.item.operator,
        docIndexes: this.item.supdocslist,
        message: [this.essInfo.supplier_documents],
        flag: "multi",
      };
      this.$refs.AdditionalDocumentsModalRef.showModal(_tmp);
    },
    openProductSupModal() {
      if (this.productSupplier) {
        this.$refs.EssentialInfoRef.showProductSup();
      }
    },
    async getVillaData(villaSupplier) {
      this.villaData = await fetchVilla(this.item.propertyid, villaSupplier);
    },
    openCvVillasModal() {
      this.$refs.cvVillasModal.show();
    },
    openSolmarVillasModal() {
      this.$refs.solmarVillasModal.show();
    },
    openJet2Modal() {
      this.$refs["Jet2InfoRef"].show();
    },
    openCheckInModal() {
      if (this.checkInSupplier) {
        this.$refs.EssentialInfoRef.showCheckInSup();
      }
    },
    openEssentialInfoModal() {
      if (this.voucherSupplier) {
        this.$refs.EssentialInfoRef.showVoucherSup();
      }
    },
    openProductDesModal() {
      if (this.productDestination) this.$refs.EssentialInfoRef.showProductDes();
    },
    showAccomInfo(data) {
      this.$refs["SQLMessageRef"].showModal(data);
    },
    openGeneralModal() {
      let _arr = [];
      let _obj;
      this.item.meetmsg.forEach((element) => {
        _obj = {
          ...element,
          sqlCodes: [{ code: this.item.meetmsg[0].msgcode }],
          meet_and_greet: true,
        };
        _arr.push(_obj);
      });

      this.$refs.GroundGeneralModalRef.showModal(_arr);
    },
    capitalise(text) {
      text = text.toLowerCase();
      let re = /(\b[a-z](?!\s))/g;
      let regexText = text.replace(re, (x) => x.toUpperCase());

      return regexText;
    },
    checkJsonData(htlcode) {
      fetch(`https://www.trailfinders.com/webdata/hotels/supplierforVT/${htlcode}`)
        .then((r) => r.json())
        .then((json) => {
          this.json = json;
        })
        .catch(() => {
          this.json = [];
        });
    },
    isCvVilla(supplierId) {
      const split = supplierId.split("HOT");
      if (split.length > 1) {
        let suppNum = split[1];
        // cv villas have supplier number HOT260, 261 etc, up to HOT270
        if (Number(suppNum) >= 260 && Number(suppNum) <= 270) {
          return true;
        }
      }
      return false;
    },
    async openNewVoucherModal(string) {
      const data = await fetchVoucherInformation(string);
      if (data) {
        this.voucherInformation = data;
        this.$refs.VouchersModalRef.show();
      }
    },
    async voucherError() {
      await reportVoucherError(this.bookingNumber, this.item);
    },
    isSolmarVilla(supplierId) {
      const split = supplierId.split("HOT");
      if (split.length > 1) {
        let suppNum = Number(split[1]);
        // solmar villas have supplier id of HOT240 or HOT241
        if (suppNum === 240 || suppNum === 241) {
          return true;
        }
      }
      return false;
    },
    isValidProductType() {
      const actionRequired = this.item.essentialInformation.checkInEssential[0]
      if (!actionRequired) return false

      const supplier = actionRequired.suppliers.find((supplier) => supplier.code === this.item.supplier)
      if (!supplier) return false
      if (!supplier.type || !supplier.type.length) {
        supplier.type  = [...this.productTypeOptions]
      }
      return this.matchedType(this.item.jsontype, supplier)
    },
    matchedType(type, supplier) {
      // Sfacts does not pass line type to match so need to identify based on unique json fields:
      switch (type) {
        case 'tour':
          if (this.item.tourtype === 'CRUISE') {
            // Cruise is not passed as it's own category - it is passed as jsontype 'tour' and tourtype is 'CRUISE'
            return supplier.type.includes('Cruise (CRS)')
          }
          return [
            'Adventure Tour (ADV)', 
            'Escorted Tour (ESC)', 
            'Local Tour (ITX)', 
            'Multi Day Tour (ITX)'
          ].some((item) => supplier.type.includes(item))
        case 'hotel':
          return supplier.type.includes('Hotel (HTL)')
        case 'transfer':
          return supplier.type.includes('Transfer (TRF)')
        case 'rail':
          return supplier.type.includes('Rail (RAI)')
        case 'vehicle':
          // Motorhomes not passed as their own category, so need also to check vehicletype for MOTORHOME RENTAL
          if (this.item.vehicletype === 'MOTORHOME RENTAL') {
            return supplier.type && supplier.type.includes('Motorhome Rental (VAN)')
          }
          return supplier.type.includes('Car Hire (CAR)')
        default:
          return false
      }
    }
  },
};
</script>

<style></style>
